import { render, staticRenderFns } from "./ScarCheck.vue?vue&type=template&id=0f86d6ce&scoped=true"
import script from "./ScarCheck.vue?vue&type=script&lang=js"
export * from "./ScarCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f86d6ce",
  null
  
)

export default component.exports